import { useState, useEffect, useRef } from 'react';
import abb from '../assets/marcas/abb.png';
import airtac from '../assets/marcas/airtac.jpg';
import allenbradley from '../assets/marcas/allenbradley.jpg';
import autonics from '../assets/marcas/autonics.jpg';
import balluff from '../assets/marcas/balluff.png';
import banner from '../assets/marcas/banner.jpg';
import bimba from '../assets/marcas/bimba.png';
import bussmann from '../assets/marcas/bussmann.jpg';
import eaton from '../assets/marcas/eaton.jpg';
import festo from '../assets/marcas/festo.png';
import fluke from '../assets/marcas/fluke.jpg';
import generalelectric from '../assets/marcas/generalelectric.png';
import htm from '../assets/marcas/htm.png';
import ifm from '../assets/marcas/Ifm.png';
import item from '../assets/marcas/item.jpg';
import keyence from '../assets/marcas/keyence.jpg';
import omron from '../assets/marcas/omron.jpg';
import parker from '../assets/marcas/parker.jpg';
import pepperl from '../assets/marcas/pepperl.png';
import schneider from '../assets/marcas/shneider.jpg';
import siemens from '../assets/marcas/siemens.jpg';
import smc from '../assets/marcas/smc.jpg';
import stc from '../assets/marcas/stc.jpg';
import tslots from '../assets/marcas/tslots.png';
import turck from '../assets/marcas/turck.jpg';
import fath from '../assets/marcas/fath.jpg';
import alutp from '../assets/marcas/alutp.jpg';
import stanley from '../assets/marcas/stanley.png';
import honeywell from '../assets/marcas/honeywell.png';
import truper from '../assets/marcas/truper.png';
import hanyoung from '../assets/marcas/hanyoung.jpg';
import locline from '../assets/marcas/locline.png';


const brands = [
  { name: 'ABB', logo: abb },
  { name: 'AirTAC', logo: airtac },
  { name: 'Allen-Bradley', logo: allenbradley },
  { name: 'Autonics', logo: autonics },
  { name: 'Balluff', logo: balluff },
  { name: 'Banner', logo: banner },
  { name: 'Bimba', logo: bimba },
  { name: 'Bussmann', logo: bussmann },
  { name: 'Eaton', logo: eaton },
  { name: 'Festo', logo: festo },
  { name: 'Fluke', logo: fluke },
  { name: 'General Electric', logo: generalelectric },
  { name: 'HTM Sensors', logo: htm },
  { name: 'IFM', logo: ifm },
  { name: 'Item', logo: item },
  { name: 'Keyence', logo: keyence },
  { name: 'Omron', logo: omron },
  { name: 'Parker', logo: parker },
  { name: 'Pepperl+Fuchs', logo: pepperl },
  { name: 'Schneider Electric', logo: schneider },
  { name: 'Siemens', logo: siemens },
  { name: 'SMC', logo: smc },
  { name: 'STC Valve', logo: stc },
  { name: 'TSLOTS', logo: tslots },
  { name: 'Turck', logo: turck },
  { name: 'Fath', logo: fath },
  { name: 'Honeywell', logo: honeywell },
  { name: 'Truper', logo: truper },
  { name: 'hangyoung nux', logo: hanyoung },
  { name: 'LocLine', logo: locline },
  { name: 'Alutp', logo: alutp },
  { name: 'Stanley', logo: stanley },
  // Duplicar para efecto scroll infinito
  { name: 'ABB', logo: abb },
  { name: 'AirTAC', logo: airtac },
  { name: 'Allen-Bradley', logo: allenbradley },
  { name: 'Autonics', logo: autonics },
  { name: 'Balluff', logo: balluff },
  { name: 'Banner', logo: banner },
  { name: 'Bimba', logo: bimba },
  { name: 'Bussmann', logo: bussmann },
  { name: 'Eaton', logo: eaton },
  { name: 'Festo', logo: festo },
  { name: 'Fluke', logo: fluke },
  { name: 'General Electric', logo: generalelectric },
  { name: 'HTM Sensors', logo: htm },
  { name: 'IFM', logo: ifm },
  { name: 'Item', logo: item },
  { name: 'Keyence', logo: keyence },
  { name: 'Omron', logo: omron },
  { name: 'Parker', logo: parker },
  { name: 'Pepperl+Fuchs', logo: pepperl },
  { name: 'Schneider Electric', logo: schneider },
  { name: 'Siemens', logo: siemens },
  { name: 'SMC', logo: smc },
  { name: 'STC Valve', logo: stc },
  { name: 'TSLOTS', logo: tslots },
  { name: 'Turck', logo: turck },
  { name: 'Fath', logo: fath },
  { name: 'Honeywell', logo: honeywell },
  { name: 'Truper', logo: truper },
  { name: 'hangyoung nux', logo: hanyoung },
  { name: 'LocLine', logo: locline },
  { name: 'Alutp', logo: alutp },
  { name: 'Stanley', logo: stanley },
];

const HomeBrandsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('home-brands');
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isVisible && scrollRef.current) {
      const scrollContainer = scrollRef.current;
      let scrollAmount = 0;
      const scrollSpeed = 3; // Ajusta la velocidad del scroll

      const animateScroll = () => {
        scrollAmount += scrollSpeed;
        if (scrollAmount >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
          scrollAmount = 0; // Reinicia el scroll para el efecto infinito
        }
        scrollContainer.scrollLeft = scrollAmount;
        requestAnimationFrame(animateScroll);
      };

      const animationFrame = requestAnimationFrame(animateScroll);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [isVisible]);

  return (
    <section id="home-brands" className="py-20 px-4 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className={`text-4xl font-bold text-gray-900 mb-16 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          Distribuidores <span className="text-red-600">Autorizados</span>
        </h2>
        <div 
          ref={scrollRef} 
          className="flex overflow-x-hidden whitespace-nowrap py-4" // Contenedor para el scroll
          style={{ scrollBehavior: 'auto' }} // Deshabilita el scroll suave nativo
        >
          {brands.map((brand, index) => (
            <div 
              key={index} 
              className={`inline-block mx-8 flex-shrink-0 flex justify-center items-center p-4 bg-gray-50 rounded-lg shadow-md transform hover:scale-110 transition-all duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
              style={{ width: '180px' }} // Ancho fijo para cada logo
            >
              <img src={brand.logo} alt={brand.name} className="h-16 w-auto object-contain" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default HomeBrandsSection;